import { useState, useCallback } from 'react';
import { useOrgStack } from '@/hooks/ceox/useOrgStack';
import { useSeoFetch } from '@/hooks/useSeoFetch';
import { getActiveOrgId } from '@/lib/activeOrg';
import ceoxSettingsService, { SQLTargets } from '@/services/ceoxSettings';
import { OrgStack } from '@/types/api/ceoxStack';
import CEOxSettingsComponent from './CEOxSettings.component';

const CEOxSettingsContainer = function (): JSX.Element {
  const orgId = getActiveOrgId();

  const { data: sqlTargets, refetch } = useSeoFetch<SQLTargets>(
    ['ceox-sql-targets', orgId],
    () => ceoxSettingsService.getSQLTargets(),
    { retry: false }
  );

  const { stack, isLoading: isStackLoading } = useOrgStack();

  const [isSaving, setIsSaving] = useState(false);

  const handleSave = useCallback(
    async (targets: SQLTargets) => {
      setIsSaving(true);
      try {
        await ceoxSettingsService.updateSQLTargets(targets);
        refetch();
      } finally {
        setIsSaving(false);
      }
    },
    [refetch]
  );

  return (
    <CEOxSettingsComponent
      sqlTargets={sqlTargets ?? null}
      isSaving={isSaving}
      onSave={handleSave}
      stack={isStackLoading ? null : (stack as OrgStack | null)}
    />
  );
};

export default CEOxSettingsContainer;
